import React, { useEffect, useState } from 'react';
import { Input, Switch, Button, Form, Upload, message, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '../../api';

const SiteSettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/panel/setting/manage?per_page&page');
      form.setFieldsValue(response.data.data);
    } catch (error) {
      message.error('خطا در دریافت تنظیمات سایت');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.post('/panel/setting/storeManage', values);
      message.success('تنظیمات با موفقیت ذخیره شد');
    } catch (error) {
      message.error('خطا در ذخیره تنظیمات');
    }
    setLoading(false);
  };

  return (
    <Card>
      <h2 className="text-2xl font-bold mb-6"> تنظیمات سایت</h2>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <div className="flex gap-4">
          <Form.Item label="نام سایت" name="name" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="عنوان سایت" name="title" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>



        <div className="flex gap-4">
          <Form.Item label="آدرس ایمیل" name="email" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="شماره تماس" name="number" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item label="آدرس نماد اعتماد الکترونیکی" name="etemad" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="آدرس مرکز فناوری اطلاعات دیجیتال" name="fanavari" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>

        {/* <div className="flex gap-4">
          <Form.Item label="توکن تاپین" name="tokenTapin" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="شناسه فروشگاه تاپین" name="shopTapin" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div> */}

        <div className="flex gap-4">
          <Form.Item label="آدرس اینستاگرام" name="instagram" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="آدرس توییتر" name="twitter" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item label="آدرس تلگرام" name="telegram" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="فیسبوک" name="facebook" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item label="آدرس سایت" name="address" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          {/* <Form.Item label=" درصد بیعانه" name="price_inquiry" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item> */}
        </div>

        <Form.Item label="درباره ما" name="about">
          <Input.TextArea rows={4} className="rounded-md" />
        </Form.Item>

        <div className="flex space-x-4 mb-4">
          <Form.Item label="نمایش کپچا" name="captcha" valuePropName="checked" className="flex-1">
            <Switch defaultChecked={form.getFieldValue('captcha') === '1'} />
          </Form.Item>

          <Form.Item label="استعلام قیمت برای همه محصولات" name="price_inquiry" valuePropName="checked" className="flex-1">
            <Switch defaultChecked={form.getFieldValue('price_inquiry') === '1'} />
          </Form.Item>

          <Form.Item label="تأییدیه" name="verify" valuePropName="checked" className="flex-1">
            <Switch defaultChecked={form.getFieldValue('verify') === '1'} />
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item label="نمایش تعداد کالا در هر اسلایدر دسته بندی" name="showPostCategory" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
          <Form.Item label="تعداد پست برای صفحه بندی" name="showPostPage" className="flex-1">
            <Input className="rounded-md" />
          </Form.Item>
        </div>

        {/* <Form.Item label="لوگو" name="logo">
          <Upload name="logo" listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>آپلود لوگو</Button>
          </Upload>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} className=" mt-4">
            ذخیره تغییرات
          </Button>
        </Form.Item>
      </Form>
      </Card>
  );
};

export default SiteSettings;